import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ------------------------------
// Disattiva eventuale Service Worker di CRA
// ------------------------------
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}

// ------------------------------
// (Facoltativo) intercetta errori globali axios o fetch
// ------------------------------
window.addEventListener('unhandledrejection', (event) => {
  console.warn('Promise non gestita:', event.reason);
});

// ------------------------------
// Bootstrap React
// ------------------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ------------------------------
// Performance (puoi disattivare se non serve)
// ------------------------------
reportWebVitals();
